import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@rocketlane/rocket-router';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';
import { RoutePaths } from 'constant';
const ForgotPasswordLink = styled(Link)`
  ${BodyShort01};
  white-space: nowrap;
`;
export const ForgotPassword = ({ isSamlMandate })=>{
    if (isSamlMandate) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ForgotPasswordLink, {
        to: RoutePaths.forgotPassword,
        children: /*#__PURE__*/ _jsx(FormattedMessage, {
            id: "forgot_password"
        })
    });
};
